import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';

import { RoutesEntityGrid } from '../features/routes-entity-grid/routes-entity-grid';

export const AllRoutesPage = observer(() => {
  return (
    <AppPage perm="*" noWrapper>
      <RoutesEntityGrid />
    </AppPage>
  );
});
